import { jsx as e } from "react/jsx-runtime";
import { ad as r } from "../../../vendor-CPVnY93G.js";
import "react";
import "../../../theme/spacing.js";
import { omitStyleRenderProps as t } from "../../../utils/omitStyleRenderProps/index.js";
import '../../../assets/index30.css';const n = "_menu_1mmlo_1", s = {
  menu: n
};
function f({ children: m, ...o }) {
  return /* @__PURE__ */ e(r, { ...t(o), slot: "menu", className: s.menu, children: m });
}
export {
  f as Menu
};
